import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Alert from "react-bootstrap/Alert";

import TitleBar from '../../../components/TitleBar';
import { login } from '../slice';

import styles from './styles.module.css'
import { Link } from 'react-router-dom';
import { reissuePasswordUrl } from '../../ReissuePassword/urls';
import { consentUrl } from '../../Inquiry/urls';
import BottomBar from '../../../components/BottomBar';

const Login = () => {
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');
  const result = useSelector((state) => state.login);
  const dispatch = useDispatch();

  let forbiddenMessage = null;
  if (result.forbidden) {
    forbiddenMessage = (
      <div className={styles.item} role="alert">
        まだログインしていないか、セッションが切れました。ログインし直してください。
      </div>
    )
  }
  let errorMsg = null;
  if (result.message) {
    errorMsg = (
      <Alert variant="danger">{result.message}</Alert>
    );
  }

  return (
    <>
      <form onSubmit={(e) => {
        dispatch(login(id, pw));
        e.preventDefault();
      }}>
        <TitleBar />
        {errorMsg}
        <div className={styles.title} >
          ログイン
          <br />
          <div className='en'>
            Log in
          </div>
        </div >
        <div className={styles.loginform}>
          <div className={styles.item}>
            <label htmlFor="id" className="form-label">ユーザーID<br />User ID</label>
            <input id="id" type="text" className="form-control"
              value={id}
              onChange={(e) => setId(e.target.value)} />
          </div>
          <div className={styles.item}>
            <label htmlFor="password" className="form-label">パスワード<br />Password</label>
            <input id="password" type="password" className="form-control"
              value={pw}
              onChange={(e) => setPw(e.target.value)} />
          </div>
          {forbiddenMessage}
          <div className={styles.item}>
            <button className="btn btn-primary" type="submit">
              ログイン
              <br />
              Log in
            </button>
          </div>
          <div>
            <div style={{ marginTop: '0.6rem' }}>
              <Link to={reissuePasswordUrl()}>パスワードをお忘れの方はこちら<br /><div className='en'>Forgot your password?</div></Link>
            </div>
            <div style={{ marginTop: '0.6rem' }}>
              <Link to={consentUrl('account')}>アカウントをお持ちでない方はこちら<br /><div className='en'>Do not have an account?</div></Link>
            </div>
          </div>
        </div>
      </form>
      <BottomBar />
    </>
  );
};

export default Login;
